const createStagedTimer = function ({ times, onStage }) {
  let shouldContinue = true
  const f = function (_times, index) {
    if (_times.length === 0) return
    const [t, ...ts] = _times
    setTimeout(function () {
      if (!shouldContinue) return
      onStage(index)
      f(ts, index + 1)
    }, t)
  }
  f(times, 0)
  return function stopTimer () {
    shouldContinue = false
  }
}

const createAsyncTaskGroup = function ({ debounceDelay, onStart, onEnd }) {
  let taskCount = 0
  let isEnded = true
  let onEndTimer = -1
  return {
    addTask () {
      if (isEnded) {
        isEnded = false
        onStart()
      }
      taskCount += 1
      clearTimeout(onEndTimer)
    },
    finishTask () {
      taskCount -= 1
      if (taskCount < 1) {
        onEndTimer = setTimeout(() => {
          isEnded = true
          onEnd()
        }, debounceDelay)
      }
    }
  }
}

export { createStagedTimer, createAsyncTaskGroup }
